import { getAll } from '../../api';
import { setFilterOptions } from '@/_store/utils/digitalKeys/setFilterOptions';
import { filter } from '@/_store/utils/app/filter';
import { search as createSearch } from '@/_store/utils/app/search';

// initial users state
const state = {
  data: [{}],
  queryParams: {
    page: 1,
    itemsPerPage: 12,
  },
  tokens: [undefined],
  currentTokenIndex: 1,
  createKey: false,
  keyCreate: '',
};

// getters
const getters = {
  getData(state) {
    return state.data;
  },
  getQueryParams(state) {
    return state.queryParams;
  },
  getCreateKey(state) {
    return state.createKey;
  },
  getTokens(state) {
    return state.tokens;
  },
  getCurrentTokenIndex(state) {
    return state.currentTokenIndex;
  },
  getKeyCreate(state) {
    return state.keyCreate;
  },
};

// actions
const actions = {
  acquireData: async ({
    commit, rootState, rootGetters, dispatch,
  }) => new Promise((resolve, reject) => {
    commit('loading/setLoading', true, { root: true });
    const filters = rootState.filters.filter;
    let variables = {};
    const user_groups = rootGetters['account/getCurrentUser'].group_id
        && rootGetters['account/getCurrentUser'].group_id[0];
    if (user_groups && user_groups !== 'all') {
      variables.group_id = user_groups;
    } else if (filters.location !== undefined && filters.location !== '') {
      variables.group_id = filters.location;
    }

    let indexType = 'all';
    if (variables.group_id) {
      indexType = 'group';
    }

    const filterParams = ['used'];
    let filterVariables = filter(filterParams);
    const search = createSearch();
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    variables = JSON.stringify(variables).replace(/"([^"]+)":/g, '$1: ');
    filterVariables = JSON.stringify(filterVariables).replace(
      /"([^"]+)":/g,
      '$1: ',
    );

    getAll(
      `/digitalkey?query=${
        encodeURIComponent(
          `{get(type_name: "digital_key", 
            filters: ${filterVariables},
            search: ${search},
            digital_key: ${variables}, 
            table_name:"${clientTable}", 
            index: "${indexType}-index"
          ){
            uuid, 
            code,
            phone,
            email,
            used,
            group_id,
            expected_return,
            error, 
            success
          }}`,
        )}`,
    )
      .then((res) => {
        const allGroups = rootState.account.currentClient.groups;
        res.data.data.get.map((key) => {
          key.group = allGroups.find((group) => group.uuid === key.group_id);
        });
        res.data.data.get.sort((a, b) => (a.expected_return < b.expected_return ? 1 : -1));
        commit('setData', res.data.data.get);
        setFilterOptions();
        dispatch('filters/setToken', res.data.data.get.nextToken, {
          root: true,
        });
        commit('loading/setLoading', false, { root: true });
        resolve(res);
      })
      .catch((err) => {
        commit('loading/setLoading', false, { root: true });
        reject(err);
      });
  }),
  createKey: async ({ dispatch, commit, rootGetters }, payload) => {
    const key = Math.floor(
      Math.random() * (Math.floor(999999) - Math.ceil(100000))
        + Math.ceil(100000),
    );
    Object.assign(payload, {
      code: key.toString(),
      used: false,
    });
    return new Promise((resolve, reject) => {
      payload = JSON.stringify(payload).replace(/"([^"]+)":/g, '$1: ');
      const clientTable = rootGetters['account/getCurrentClient'].table_name;
      getAll(
        `/digitalkey?query=${
          encodeURIComponent(
            `mutation{create(type_name: "digital_key", 
            digital_key: ${payload}
            table_name:"${clientTable}", 
          ){
            uuid, 
            error, 
            success
          }}`,
          )}`,
        payload,
      )
        .then((res) => {
          resolve(res);
          commit('setKeyCreate', 'New Key Created');
          dispatch('acquireData');
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

// mutations
const mutations = {
  setData(state, payload) {
    payload = payload.filter((key) => key.expected_return != null);
    payload.sort((a, b) => a.expected_return.toString().localeCompare(b.expected_return.toString()));
    state.data = payload;
  },
  setQueryParams(state, payload) {
    state.queryParams = payload;
  },
  setCreateKey(state, payload) {
    state.createKey = payload;
  },
  setTokens(state, payload) {
    if (!state.tokens.includes(payload)) {
      state.tokens.push(payload);
    }
  },
  setCurrentTokenIndex(state, payload) {
    state.currentTokenIndex = payload;
  },
  setKeyCreate(state, payload) {
    state.keyCreate = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
